import { isPlainObject } from 'lodash-es';
import { generateUUID } from './generateUUID';

export const createHeaders = ({
  appEIMId,
  channelId,
  sessionId,
  countryCode,
  groupMember,
}) => {
  return {
    Accept: 'application/json',
    'X-HSBC-Channel-Id': channelId,
    'X-HSBC-Global-Channel-Id': 'WEB',
    'X-HSBC-Chnl-Group-Member': isPlainObject(groupMember)
      ? groupMember[window.__BRAND__]
      : groupMember,
    'X-HSBC-Chnl-CountryCode': countryCode,
    'X-HSBC-Session-Correlation-Id': sessionId,
    'X-HSBC-Request-Correlation-Id': generateUUID(),
    'X-HSBC-Locale': 'en_SG',
    'X-HSBC-Source-System-Id': appEIMId,
    'cache-control': 'no-cache',
    Pragma: 'no-cache',
  };
};
